import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import DateLib from "../../../../inc/DateLib";
import "../styles.css";

// Поле даты-времени. value — Date | строка сервера | null (Formatter.Date отдаёт Date).
// readOnly — человекочитаемый текст; редактирование — нативный datetime-local.
export default function InputDatetime({ value = null, children, errors, className = '', hasLabel = true, readOnly = false, ...other }) {
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        {readOnly
            ? <input
                type="text"
                readOnly={true}
                value={DateLib.formatterDateTime(value)}
                className={`input ${className}`}
            />
            : <input
                {...other}
                type="datetime-local"
                value={DateLib.formatterForInput(value)}
                className={`input ${className}`}
            />}
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
